import { render } from "./CustomSwiper.vue?vue&type=template&id=5e14b23c"
import script from "./CustomSwiper.vue?vue&type=script&lang=js"
export * from "./CustomSwiper.vue?vue&type=script&lang=js"

import "./CustomSwiper.vue?vue&type=style&index=0&id=5e14b23c&lang=scss"

import exportComponent from "D:\\Word\\mingyou\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__